export default __webpack_public_path__ + "static/media/diamond.e338251c.svg";